export function parseProductPrice(value) {
  if (value == null || value === '') return 0;
  const cleaned = String(value).replace(/[^\d.-]/g, '');
  const num = Number(cleaned);
  return Number.isFinite(num) ? num : 0;
}

export function formatPrice(value) {
  const num = typeof value === 'number' ? value : parseProductPrice(value);
  return num.toLocaleString();
}

export function formatProductPrice(product) {
  const price = product?.price;
  if (price == null || price === '') return '';
  return formatPrice(price);
}

export function formatProductOriginalPrice(product) {
  const original = product?.originalPrice;
  if (original == null || original === '') return '';
  return formatPrice(original);
}

export function lineTotal(price, quantity) {
  return parseProductPrice(price) * quantity;
}

export function saleUnitPrice(product) {
  return parseProductPrice(product?.price);
}

export function originalUnitPrice(product) {
  if (product?.originalPrice) return parseProductPrice(product.originalPrice);
  return saleUnitPrice(product);
}

export function hasProductDiscount(product) {
  const hide = product?.hidePrice ?? product?.hide_price;
  if (hide === true || hide === 'true' || Number(hide) === 1) return false;
  return (
    Boolean(product?.originalPrice) ||
    (product?.discountPercent != null && product.discountPercent > 0)
  );
}

export function hasProductPrice(product) {
  const hide = product?.hidePrice ?? product?.hide_price;
  if (hide === true || hide === 'true' || Number(hide) === 1) return false;
  return saleUnitPrice(product) > 0;
}
